"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Popover = _interopRequireDefault(require("../common/Popover/Popover"));
var _InstrumentSelectorPopupComponent = _interopRequireDefault(require("./InstrumentSelectorPopupComponent"));
var _instrumentPropTypes = require("../../propTypes/instrumentPropTypes");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./InstrumentSelectorComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('instrument-selector');
var InstrumentSelectorComponent = /*#__PURE__*/function (_React$Component) {
  function InstrumentSelectorComponent(props) {
    var _this;
    _classCallCheck(this, InstrumentSelectorComponent);
    _this = _callSuper(this, InstrumentSelectorComponent, [props]);
    _defineProperty(_this, "runLevel1Updates", function () {
      return _this.updateLevel1 = true;
    });
    _defineProperty(_this, "stopLevel1Updates", function () {
      return _this.updateLevel1 = false;
    });
    _defineProperty(_this, "onRowClick", function (instrument) {
      _this.popoverRef.toggleShow();
      _this.props.selectInstrument(instrument.InstrumentId);
    });
    _this.popoverRef = null;
    _this.updateLevel1 = true;
    return _this;
  }
  _inherits(InstrumentSelectorComponent, _React$Component);
  return _createClass(InstrumentSelectorComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.instruments.length === 0) return;
      var selectedInstrument = this.props.instruments.find(function (instrument) {
        return instrument.InstrumentId === _this2.props.selectedInstrument.InstrumentId;
      });
      if (selectedInstrument) return;
      var instrumentId = this.props.instruments[0].InstrumentId;
      this.props.selectInstrument(instrumentId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (prevProps.selectedAccountId !== this.props.selectedAccountId) {
        var selectedInstrument = this.props.instruments.find(function (instrument) {
          return instrument.InstrumentId === _this3.props.selectedInstrument.InstrumentId;
        });
        if (!selectedInstrument) {
          this.props.selectInstrument(this.props.instruments[0].InstrumentId);
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return this.updateLevel1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        fetching = _this$props.fetching,
        instruments = _this$props.instruments,
        selectedInstrument = _this$props.selectedInstrument,
        selectedRow = _this$props.selectedRow,
        level1 = _this$props.level1,
        customClass = _this$props.customClass,
        showFullNameInstrument = _this$props.showFullNameInstrument,
        showTriangles = _this$props.showTriangles;
      var instrumentSymbol = '';
      if (showFullNameInstrument && selectedInstrument.Product1FullName) {
        instrumentSymbol = "".concat(selectedInstrument.Product1FullName, " / ").concat(selectedInstrument.Product2FullName);
      } else {
        instrumentSymbol = selectedInstrument.Symbol;
      }
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        ref: function ref(_ref) {
          return _this4.popoverRef = _ref;
        },
        trigger: function trigger(props) {
          return /*#__PURE__*/_react["default"].createElement("button", _extends({
            className: baseClasses('trigger')
          }, props, {
            onMouseOver: _this4.stopLevel1Updates,
            onMouseOut: _this4.runLevel1Updates
          }), /*#__PURE__*/_react["default"].createElement("span", {
            className: baseClasses('symbol')
          }, instrumentSymbol), showTriangles ? /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClasses('triangles-container')
          }, /*#__PURE__*/_react["default"].createElement("span", {
            className: 'triangle-up'
          }), /*#__PURE__*/_react["default"].createElement("span", {
            className: 'triangle-down'
          })) : /*#__PURE__*/_react["default"].createElement("span", {
            className: baseClasses('triangle')
          }));
        },
        content: /*#__PURE__*/_react["default"].createElement(_InstrumentSelectorPopupComponent["default"], {
          onRowClick: this.onRowClick,
          fetching: fetching,
          instruments: instruments,
          selectedRow: selectedRow,
          level1: level1,
          customClass: customClass,
          showFullNameInstrument: showFullNameInstrument
        }),
        customClass: "instrument-selector-popover",
        drawArrow: true
      });
    }
  }]);
}(_react["default"].Component);
InstrumentSelectorComponent.propTypes = {
  level1: _propTypes["default"].object.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  fetching: _propTypes["default"].bool.isRequired,
  selectedAccountId: _propTypes["default"].number.isRequired,
  selectedInstrument: _instrumentPropTypes.instrumentPropType,
  selectedRow: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = InstrumentSelectorComponent;